import { PureComponent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { connect } from 'react-redux';

import { toggleKeyboardShortcutMenu as toggleMenu } from 'src/redux/global/actions/toggle-keyboard-shortcut-menu';
import { KeyboardShortcuts } from 'src/redux/keyboard-shortcuts';
import { BucketState } from 'src/types/state';

import { keyboardShortcutDialogMessages } from './keyboard-shortcut-dialog.i18n';
import { KeyboardShortcutMenu } from './keyboard-shortcut-menu';
import ModalDialogActions from './modal-dialog-actions';

type Props = {
  intl: IntlShape;
  isOpen: boolean;
  shortcuts: KeyboardShortcuts;
  toggleMenu: (isOpen?: boolean) => void;
};

class KeyboardShortcutDialog extends PureComponent<Props> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    shortcuts: {},
    toggleMenu: () => {},
  };

  actions = [
    {
      onClick: () => this.close(),
      text: this.props.intl.formatMessage(
        keyboardShortcutDialogMessages.closeButton
      ),
    },
  ];

  close = () => {
    this.props.toggleMenu(false);
  };

  render() {
    const { intl, isOpen, shortcuts } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <ModalDialogActions
        actions={this.actions}
        heading={intl.formatMessage(keyboardShortcutDialogMessages.heading)}
        onClose={this.close}
        width="small"
      >
        <KeyboardShortcutMenu shortcuts={shortcuts} intl={intl} />
      </ModalDialogActions>
    );
  }
}

const mapDispatchToProps = { toggleMenu };
const mapStateToProps = (state: BucketState) => ({
  isOpen: state.global.isKeyboardShortcutMenuOpen,
  shortcuts: state.keyboardShortcuts,
});

// eslint-disable-next-line import/no-default-export
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(KeyboardShortcutDialog));
